import { render, staticRenderFns } from "./bindFlowApi.vue?vue&type=template&id=4685767e"
import script from "./bindFlowApi.vue?vue&type=script&lang=js"
export * from "./bindFlowApi.vue?vue&type=script&lang=js"
import style0 from "./bindFlowApi.vue?vue&type=style&index=0&id=4685767e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports